export default __webpack_public_path__ + "static/media/luis.6ac3aba7.jpg";